import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=95c063ca&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95c063ca')) {
      api.createRecord('95c063ca', component.options)
    } else {
      api.reload('95c063ca', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=95c063ca&", function () {
      api.rerender('95c063ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-287ro39aj7S7n/JS/comp/childrenage.vue"
export default component.exports